export default class Response<TEntity>{
  public object: TEntity;
  public headers: Headers
}
